import React, { Component } from "react";
import { Layout, Menu, Row, Dropdown, Avatar } from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  FileDoneOutlined,
  ProfileOutlined,
  FileTextOutlined,
  SettingOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";
import { Route, Switch, Redirect, NavLink } from "react-router-dom";
import "antd/dist/antd.css";
import "../../style.css";
import router from "../../routes/adminRoutes";
import ssoAuth from "../../hoc/ssoAuth";
import menuKeys from "../../helpers/menu";
import signOut from "helpers/signOut";
import Logo from "assets/img/ASA LOGO ONLY.png";

const { Header, Content, Footer, Sider } = Layout;

const menu = (
  <Menu>
    <Menu.Item key="0" onClick={() => signOut("/admin")}>
      Logout
    </Menu.Item>
  </Menu>
);

class Admin extends Component {
  state = {
    selectedMenu: "/admin",
  };

  setMenu = () => {
    const splited = this.props.location.pathname.split(new RegExp("/"));
    let location = this.props.location.pathname;
    let i = splited.length;
    while (!menuKeys[location] && i >= 0) {
      location = location.replace("/" + splited[i], "");
      i--;
    }

    this.setState({ selectedMenu: menuKeys[location] || "0" });
  };

  componentDidMount() {
    this.setMenu();
  }

  onCLickMenu = (param) => {
    this.setState({ selectedMenu: param.key });
  };

  render() {
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <div style={{ position: "fixed", zIndex: 9999 }}>
          <Sider
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={(broken) => {
              // console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
              // console.log(collapsed, type);
            }}
            style={{
              height: "100vh",
            }}
          >
            <Row>
              <img src={Logo} alt="logo" className="logo" />
            </Row>
            <Menu
              theme="dark"
              mode="inline"
              defaultSelectedKeys={[0]}
              selectedKeys={[this.state.selectedMenu]}
              onClick={this.onCLickMenu}
            >
              <Menu.Item key={0}>
                <NavLink to="/admin">
                  <DashboardOutlined />
                  <span className="nav-text">Dashboard</span>
                </NavLink>
              </Menu.Item>
              {["admin", "operator"].includes(this.props.user.info.type) ? (
                <Menu.Item key={1}>
                  <NavLink to="/admin/users">
                    <UserOutlined />
                    <span className="nav-text">Users</span>
                  </NavLink>
                </Menu.Item>
              ) : null}
              {this.props.user.info.type === "admin" ? (
                <Menu.Item key={2}>
                  <NavLink to="/admin/master-surat">
                    <FileDoneOutlined />
                    <span className="nav-text">Master Surat</span>
                  </NavLink>
                </Menu.Item>
              ) : null}
              {this.props.user.info.type === "operator" ||
              this.props.user.info.type === "prodi" ? (
                <Menu.Item key={8}>
                  <NavLink to="/admin/nomor-surat">
                    <ProfileOutlined />
                    <span className="nav-text">Kode Surat</span>
                  </NavLink>
                </Menu.Item>
              ) : null}
              {["admin", "operator", "prodi", "guest"].includes(
                this.props.user.info.type
              ) ? (
                <Menu.Item key={4}>
                  <NavLink to="/admin/surat">
                    <FileTextOutlined />
                    <span className="nav-text">Permohonan Surat</span>
                  </NavLink>
                </Menu.Item>
              ) : null}
              {/* {
                    (this.props.user.info.type === 'operator') ?
                    <Menu.Item key={5}>
                        <NavLink to="/admin/edaran">
                            <ProfileOutlined />
                            <span className="nav-text">Surat Edaran</span>
                        </NavLink>
                    </Menu.Item>:null
                    }    */}
              {this.props.user.info.type === "operator" ? (
                <Menu.Item key={6}>
                  <NavLink to="/admin/laporan">
                    <FileSearchOutlined />
                    <span className="nav-text">Laporan</span>
                  </NavLink>
                </Menu.Item>
              ) : null}
              {this.props.user.info.type === "operator" ||
              this.props.user.info.type === "prodi" ? (
                <Menu.Item key={3}>
                  <NavLink to="/admin/pengaturan">
                    <SettingOutlined />
                    <span className="nav-text">Pengaturan</span>
                  </NavLink>
                </Menu.Item>
              ) : null}
            </Menu>
          </Sider>
        </div>
        <Layout className="main-layout">
          <Header
            className="site-layout-sub-header-background"
            style={{ padding: 0 }}
          >
            <div style={{ float: "right", marginRight: 10 }}>
              <Dropdown overlay={menu} trigger={["click"]}>
                <div style={{ cursor: "pointer" }}>
                  <span>{this.props.user.name}</span>
                  <Avatar
                    src={this.props.user.user_unit.photo}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </Dropdown>
            </div>
          </Header>
          <Content style={{ margin: "24px 16px 0" }}>
            <Switch>
              {router.map((nav, index) => {
                if (nav.auth.includes(this.props.user.info.type)) {
                  return (
                    <Route
                      key={index}
                      path={nav.path}
                      render={(props) => (
                        <nav.component {...props} user={this.props.user} />
                      )}
                      exact={nav.exact}
                    />
                  );
                }
                return null;
              })}
              <Redirect from="*" to="/404" />
            </Switch>
          </Content>
          <Footer style={{ textAlign: "center" }}>
            ©2020 Aplikasi Satu Atap USU
          </Footer>
        </Layout>
      </Layout>
    );
  }
}

export default ssoAuth(Admin);
